import { useCallback } from "react";

import { showToast } from "@/providers/ToastProvider";

export function useCopyToClipboard() {
  return useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      showToast([{ heading: "Copied to clipboard.", variant: "success" }]);
    } catch {
      // silent fail — clipboard API requires HTTPS and user permission
    }
  }, []);
}
